export default __webpack_public_path__ + "static/media/crc-block-user.7ea5caa6.svg";